var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detect-mobile"},[(!_vm.err_msg)?_c('div',{staticClass:"spinner-border text-success",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),(_vm.err_msg)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.err_msg))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }